import React from 'react';
import _get from 'lodash.get';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Loadable from 'react-loadable';
import MiniTvSS from 'components/MiniTvV2/MiniTvSS';
import { debugLogs } from 'utils/common';
import { getCookie } from 'utils/cookies';
import {
  closeVideoTheatre,
  loadMiniTvComponent,
} from 'routes/articleshow/redux';
import { loadMiniTvComponentV2 } from 'routes/articleshow_v2/redux';
import { loadMiniTv, showMiniTvPlayer, getMinitvConfig } from './redux';

const LoadableComponentV2 = Loadable({
  loader: () =>
    import(/* webpackChunkName: 'MiniTv' */ 'components/MiniTvV2/MiniTv'),
  loading: () => null,
});

class WithMiniTv extends React.PureComponent {
  constructor(props) {
    super(props);
    this.props.showMiniTvPlayer(true);
    this.state = {
      uiActive: false,
      hideEverything: false,
    };
    this.containerRef = React.createRef();
    this.playerBottomRef = React.createRef();
    this.loading = false;
  }

  loadMintTvFn = () => {
    if (typeof window !== 'undefined' && !this.loading) {
      this.loading = true;
      const {
        isWapView,
        isUserPrime,
        jarvisLayoutConfig,
        layoutConfig,
      } = this.props;
      const unsticky =
        !this.props.isSticky ||
        (this.props.isWapView && getCookie('minitvmwebClose') === 'y');

      const setting = {
        isWapView,
        unsticky,
        isUserPrime,
        layoutConfig,
        jarvisLayoutConfig,
      };
      this.props.loadMiniTv(setting);
      if (!this.props.isWapView && getCookie('minitvClose')) {
        this.props.showMiniTvPlayer(false);
      }
    }
  };

  afterhidrationandDelay = (delay, skip) => {
    window.addEventListener('HYDRATION_COMPLETED', () => {
      setTimeout(() => {
        debugLogs(
          `MINITV->> HYDRATION_COMPLETED & 3s delay! --- skip minitv load ${skip}`,
          `${(window.performance.now() / 1000).toFixed(2)} seconds`,
        );
        if (!skip) {
          this.loadMintTvFn();
        }
      }, delay);
    });
  };

  afterPageLoad = () => {
    window.addEventListener('load', () => {
      debugLogs(
        'MINITV->> Page loaded!',
        `${(window.performance.now() / 1000).toFixed(2)} seconds`,
      );
      this.loadMintTvFn();
    });
  };

  loadTypeOfMinitv = delay => {
    this.afterhidrationandDelay(delay);
  };

  componentDidMount() {
    const miniTVDelay = _get(window, 'adsconfig.global_config.minitvDelay', 0);
    if (miniTVDelay) {
      this.loadTypeOfMinitv(miniTVDelay);
    } else {
      this.loadMintTvFn();
    }
  }

  closeMiniTvWidget = () => {
    this.setState({ hideEverything: true });
  };

  clientHtml = (clienSideActive, update = {}) => (
    <>
      {clienSideActive && (
        <LoadableComponentV2
          {...this.props}
          {...update}
          mwebfullview={this.props.mwebfullview}
          uiReady={() => this.setState({ uiActive: true })}
          closeMiniTvWidget={this.closeMiniTvWidget}
          containerRef={
            this.props.isWapView ? this.playerBottomRef : this.containerRef
          }
          donotShiftMiniTv={this.props.donotShiftMiniTv}
        />
      )}
    </>
  );

  setupLayout = () => {
    const { isInPageDock, minitvMwebInPage } = this.props;
    if (isInPageDock) {
      return {
        global: ' minitv_in_page',
        w: '400',
        sSwrapper: 'minitv_dock_wrapper',
        platWiseInPage: true,
      };
    }
    if (minitvMwebInPage) {
      return {
        global: ' mweb_in_page',
        w: '400',
        platWiseInPage: true,
      };
    }
    return {
      w: '177',
    };
  };

  render() {
    const {
      miniTvData,
      isActiveFrom,
      isWapView,
      isInPageDock,
      containerClass,
      mwebfullview,
      isUserPrime,
      skipMinitv,
    } = this.props;

    const jarvisMiniTv = getMinitvConfig(this.props?.jarvisMiniTv, this.props);
    const client = typeof window !== 'undefined';

    if (this.state.hideEverything) {
      return null;
    }
    if (skipMinitv) {
      return null;
    }
    const stickycls = miniTvData?.sticky ? 'sticky_minitv' : '';
    const clienSideActive = miniTvData;

    if (!clienSideActive && client && isActiveFrom !== '') {
      return null;
    }
    const layout = this.setupLayout();
    const { platWiseInPage = false } = layout;

    const glblclas = layout.global || '';

    const clientHtml = this.clientHtml(clienSideActive, {
      isInPageDock: platWiseInPage,
    });
    if (
      !isInPageDock &&
      !mwebfullview &&
      (!isWapView || !jarvisMiniTv?.isAdActive)
    ) {
      if (isWapView) {
        return (
          <>
            <div className={`${stickycls} ${glblclas}`}>
              <div data-resizer-target="atf,cw">{clientHtml}</div>
            </div>
            <div ref={this.playerBottomRef} />
          </>
        );
      }
      return (
        <div id="desktop_minitv_view">
          <div data-resizer-target="cw">{clientHtml}</div>
        </div>
      );
    }
    const isEditActive = isActiveFrom === 'editor';
    let ssActive = !this.state.uiActive;
    if (ssActive && isUserPrime && jarvisMiniTv?.skipPrime) {
      ssActive = false;
    }

    let containerClas = isWapView ? stickycls : '';
    containerClas += isEditActive ? ' do_animation' : '';
    containerClas += isActiveFrom === 'noMiniTV' ? ' noMiniTV' : ' minitv_cls';
    containerClas += glblclas;
    if (ssActive && !jarvisMiniTv?.imageid) {
      containerClas = '';
    }

    const serverhtml = (
      <>
        {ssActive &&
          jarvisMiniTv?.imageid && (
            <MiniTvSS
              {...this.props}
              miniTvData={jarvisMiniTv}
              layout={layout}
            />
          )}
      </>
    );
    const miniTvContent = (
      <>
        <div className={containerClas} ref={this.containerRef}>
          {serverhtml}
          {/* {isEditActive && <div className="breaking_news">Breaking News</div>} */}
          {clientHtml}
        </div>
        <div ref={this.playerBottomRef} />
      </>
    );
    return containerClass ? (
      <div className={containerClass}>{miniTvContent}</div>
    ) : (
      miniTvContent
    );
  }
}

WithMiniTv.propTypes = {
  miniTvData: PropTypes.shape({}),
  loadMiniTv: PropTypes.func.isRequired,
  isWapView: PropTypes.bool,
  showMiniTvPlayer: PropTypes.func.isRequired,
  isMiniTvPlayerShown: PropTypes.bool,
  showMiniTvSection: PropTypes.string,
  pageType: PropTypes.string,
  isUserPrime: PropTypes.bool,
  closeVideoTheatre: PropTypes.func,
  miniTvV2: PropTypes.bool,
  isTimesPointNudgeVisible: PropTypes.bool,
  isETimesNudgeVisible: PropTypes.bool,
  isadFreeNudgeVisible: PropTypes.bool,
  donotShiftMiniTv: PropTypes.bool,
  wrapperClass: PropTypes.string,
  isActiveFrom: PropTypes.string,
  minitvMwebInPage: PropTypes.bool,
  containerClass: PropTypes.string,
  isInPageDock: PropTypes.bool,
  isSticky: PropTypes.bool,
  mwebfullview: PropTypes.bool,
  jarvisMiniTv: PropTypes.shape({
    isAdActive: PropTypes.number,
  }),
  config: PropTypes.shape({}),
  layoutConfig: PropTypes.shape({}),
  jarvisLayoutConfig: PropTypes.shape({}),
  skipMinitv: PropTypes.shape({}),
};

WithMiniTv.defaultProps = {
  miniTvData: undefined,
  isWapView: false,
  isMiniTvPlayerShown: false,
  isUserPrime: false,
  closeVideoTheatre: undefined,
  showMiniTvSection: '',
  pageType: '',
  miniTvV2: false,
  isTimesPointNudgeVisible: false,
  isETimesNudgeVisible: false,
  isadFreeNudgeVisible: false,
  donotShiftMiniTv: false,
  wrapperClass: '',
  containerClass: '',
  isActiveFrom: '',
  isInPageDock: false,
  isSticky: true,
  minitvMwebInPage: false,
  mwebfullview: false,
  jarvisMiniTv: {
    isAdActive: 0,
  },
  layoutConfig: {},
  config: {},
  jarvisLayoutConfig: {},
  skipMinitv: false,
};

const mapStateToProps = state => ({
  miniTvData:
    state?.miniTv?.data?.status === '1' ? state.miniTv?.data : undefined,
  isActiveFrom: state?.miniTv?.isActiveFrom || '',
  isMiniTvPlayerShown: state.miniTv?.showMiniTvPlayer,
  isUserPrime: state.isPrime,
  isTimesPointNudgeVisible:
    state.timespointmodal && state.timespointmodal.isTimesPointNudgeVisible,
  isETimesNudgeVisible: state.etimesNudge && state.etimesNudge.visible,
  jarvisMiniTv: state?.common?.siteConfig?.revenue?.minitv || {},
  isadFreeNudgeVisible:
    state.adFreeNudge && state.adFreeNudge.isAdFreeNudgeVisible,
  jarvisLayoutConfig: _get(state, 'revenue.data.widgets.minitv', {}),
  skipMinitv: _get(state, 'revenue.data.widgets.skipMinitv', false),
});

const mapDispatchToProps = dispatch => ({
  loadMiniTv: conf => {
    dispatch(loadMiniTv(conf));
  },
  showMiniTvPlayer: isShown => {
    dispatch(showMiniTvPlayer(isShown));
  },
  closeVideoTheatre: () => {
    dispatch(closeVideoTheatre());
  },
  loadMiniTvComponent: loadedMiniTvComponent => {
    dispatch(loadMiniTvComponent(loadedMiniTvComponent));
  },
  loadMiniTvComponentV2: loadedMiniTvComponent => {
    dispatch(loadMiniTvComponentV2(loadedMiniTvComponent));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(WithMiniTv);
